import type { VersionedData } from '../shared/VersionedData';

export interface MissionContent {
  readonly objective: string;
  readonly instructions: readonly string[];
  readonly optionalTip?: string;
  /** True when the full content belongs to a later lot (L7/L8) and this is a placeholder. */
  readonly provisional?: boolean;
  readonly provisionalNote?: string;
}

const CONTENT_VERSION = 1;

export function toContentData(content: MissionContent): VersionedData {
  return {
    version: CONTENT_VERSION,
    payload: { ...content },
  };
}

function isStringArray(value: unknown): value is readonly string[] {
  return Array.isArray(value) && value.every((item) => typeof item === 'string');
}

/** Returns undefined for missing, malformed or future-versioned payloads rather than throwing. */
export function fromContentData(data: VersionedData | undefined): MissionContent | undefined {
  if (!data || data.version !== CONTENT_VERSION) return undefined;
  const { objective, instructions, optionalTip, provisional, provisionalNote } = data.payload;
  if (typeof objective !== 'string' || !isStringArray(instructions)) return undefined;
  return {
    objective,
    instructions,
    ...(typeof optionalTip === 'string' ? { optionalTip } : {}),
    ...(typeof provisional === 'boolean' ? { provisional } : {}),
    ...(typeof provisionalNote === 'string' ? { provisionalNote } : {}),
  };
}
